import { render, staticRenderFns } from "./hospitalExamineDetail.vue?vue&type=template&id=4af12d32&scoped=true"
import script from "./hospitalExamineDetail.vue?vue&type=script&lang=js"
export * from "./hospitalExamineDetail.vue?vue&type=script&lang=js"
import style0 from "./hospitalExamineDetail.vue?vue&type=style&index=0&id=4af12d32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af12d32",
  null
  
)

export default component.exports